import { axios, getConfigs } from './common';

export default class MediumTypeService {
  async getList(params) {
    return new Promise(async (resolve, reject) => {
      let url = `/medium-types`;

      const options = {};
      const configs = getConfigs('get', 'application/json', url, options);

      configs.params = params;

      axios(configs, resolve, reject);
    });
  }

  async getCount(params) {
    return new Promise(async (resolve, reject) => {
      let url = `/medium-types/count`;

      const options = {};
      const configs = getConfigs('get', 'application/json', url, options);

      configs.params = params;

      axios(configs, resolve, reject);
    });
  }
}